export const FEATURE_NAME = '@zerops/core/persistent-user-settings';
